import React, { useEffect,useRef, useState } from "react";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import {
  Box,
  TextField,
  Button,
  Paper,
  Autocomplete
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { SelectChangeEvent } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { openPopup } from "../../stateManagement/actions/popupActions";
import {
  fetchDesignationOptions,
  DesignationOption,
  deletePJP,fetchUsersByDesignationsPaginated
} from "./deleteUserPJPhelper";
import { usePortalTranslation, TranslationEnum } from "../../providers/TranslationProvider";
import DefaultHeading from "../../components/heading/DefaultHeading";
import "./deletePJP.css";

export interface User {
  id: string;
  name: string;
  designation: string;
}

export interface FilterState {
  designations: string[];
  users: User[];
  startDate: Dayjs | null;
  endDate: Date | null;
}

const DeleteUserPJP: React.FC = () => {
  const { translate } = usePortalTranslation();
  const [filters, setFilters] = useState<FilterState>({
    designations: [],
    users: [],
    startDate: null,
    endDate: null
  });
  const [userOptions, setUserOptions] = useState<User[]>([]);
const [userPage, setUserPage] = useState(0);
const [hasMoreUsers, setHasMoreUsers] = useState(true);
const [isLoadingUsers, setIsLoadingUsers] = useState(false);
const [designationOptions, setDesignationOptions] = useState<DesignationOption[]>([]);

const loadUsersPaginated = async (reset = false) => {
  if (filters.designations.length === 0 || isLoadingUsers || (!hasMoreUsers && !reset)) {
    return;
 }

  setIsLoadingUsers(true);
  const nextPage = reset ? 0 : userPage;
  const size = 500;

  const newUsers = await fetchUsersByDesignationsPaginated(filters.designations, nextPage, size);

  setUserOptions(prev => reset ? newUsers : [...prev, ...newUsers]);
  setUserPage(nextPage + 1);
  setHasMoreUsers(newUsers.length === size);
  setIsLoadingUsers(false);
};

useEffect(() => {
  setUserOptions([]);
  setUserPage(0);
  setHasMoreUsers(true);
  loadUsersPaginated(true); // Reset on designation change
}, [filters.designations]);

  

  useEffect(() => {
    const loadDesignations = async () => {
      try {
        const options = await fetchDesignationOptions();
        setDesignationOptions(options);
      } catch (error) {
        console.error("Failed to fetch designations:", error);
      }
    };
  
    loadDesignations();
  }, []);
  

  const handleDesignationChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[];
    setFilters((prev) => ({
      ...prev,
      designations: value,
      users: []
    }));
  };


  

  const handleStartDateChange = (value: unknown) => {
    if (!value || typeof value !== "object" || !dayjs.isDayjs(value)) {
      setFilters((prev) => ({
        ...prev,
        startDate: null
      }));
      return;
    }
  
    const date = (value as Dayjs).startOf("day");
    const today = dayjs().startOf("day");
  
    if (date.isBefore(today)) {
      openPopup(
        "Alert",
        translate(TranslationEnum.delete_pjp, "From date must be today or a future date."),
        () => {}
      );
      return;
    }
  
    setFilters((prev) => {
      const correctedEndDate =
        prev.endDate && dayjs(prev.endDate).isBefore(date) ? date.toDate() : prev.endDate;
  
      return {
        ...prev,
        startDate: date,
        endDate: correctedEndDate,
      };
    });
  };
  
  
  
  
  const handleEndDateChange = (value: unknown) => {
    if (!value || typeof value !== "object" || !dayjs.isDayjs(value)) {
      setFilters((prev) => ({
        ...prev,
        endDate: null
      }));
      return;
    }
  
    const date = (value as Dayjs).startOf("day");
    const today = dayjs().startOf("day");
  
    if (date.isBefore(today)) {
      openPopup(
        "Alert",
        translate(TranslationEnum.delete_pjp, "To date must be today or a future date."),
        () => {}
      );
      return;
    }
  
    if (filters.startDate && date.isBefore(filters.startDate)) {
      openPopup(
        "Alert",
        translate(TranslationEnum.delete_pjp, "To date must be same or after from date."),
        () => {}
      );
      return;
    }
  
    setFilters((prev) => ({
      ...prev,
      endDate: date.toDate()
    }));
  };
  
  

  const handleCancel = () => {
    setFilters({
      designations: [],
      users: [],
      startDate: null,
      endDate: null
    });
    setUserOptions([]);
  };
  

  const popUpSuccessMethod = useRef<any>();
const [popUpMessage, setPopUpMessage] = useState<string>("");
const [confirmationPopUp, setConfirmationPopUp] = useState(false);

// Helper method to update confirmation popup data
const updateConfirmationPopData = (message: string, methodHelper: any) => {
  popUpSuccessMethod.current = methodHelper;
  setPopUpMessage(message);
};

const handleApply = () => {
  const today = dayjs().startOf("day");
  const { startDate, endDate, users } = filters;

  // Validate presence
  if (!startDate?.isValid?.() || !endDate || !dayjs(endDate).isValid() || users.length === 0)
 {
    openPopup(
      "Alert",
      translate(TranslationEnum.delete_pjp, "Please select valid filters before applying."),
      () => {}
    );
    return;
  }

  // Validate startDate >= today
  if (startDate.isBefore(today, "day")) {
    openPopup(
      "Alert",
      translate(TranslationEnum.delete_pjp, "From date must be today or a future date."),
      () => {}
    );
    return;
  }

  // Validate endDate >= today
  const endDayjs = dayjs(endDate);
  if (endDayjs.isBefore(today, "day")) {
    openPopup(
      "Alert",
      translate(TranslationEnum.delete_pjp, "To date must be today or a future date."),
      () => {}
    );
    return;
  }

  // Validate endDate >= startDate
  if (endDayjs.isBefore(startDate, "day")) {
    openPopup(
      "Alert",
      translate(TranslationEnum.delete_pjp, "To date must be same or after from date."),
      () => {}
    );
    return;
  }

  const confirmationMessage = translate(
    TranslationEnum.delete_pjp,
    `Are you sure you want to delete delivery PJP for selected users between ${startDate.format(
      "YYYY-MM-DD"
    )} and ${endDayjs.format("YYYY-MM-DD")}?`
  );

  updateConfirmationPopData(confirmationMessage, async () => {
    try {
      const result = await deletePJP(users, startDate, endDayjs);
      openPopup(
        "Alert",
        translate(
          TranslationEnum.delete_pjp,
          "Total Delivery pjp deleted : " + result["deletedCount"]
        ),
        () => {
          window.location.reload();
        }
      );
    } catch (error) {
      console.error("Error while deleting PJP:", error);
      openPopup(
        "Alert",
        translate(TranslationEnum.delete_pjp, "Error occurred while deleting delivery PJP.")
      );
    }
  });

  setConfirmationPopUp(true);
};


  

  return (
    <div className="deletePJP-wrapper">
      <DefaultHeading
        heading={translate(TranslationEnum.delete_pjp, "Delete User PJP")}
        showDefaultBackButton={true}
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Paper elevation={3} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
        <Box display="flex" flexDirection="column" gap={2}>
            {/* Designation */}
            <Autocomplete
  multiple
  disableCloseOnSelect
  options={designationOptions}
  getOptionLabel={(option) => option.label}
  value={designationOptions.filter((d) => filters.designations.includes(d.value))}
  onChange={(_, newValue) => {
    const selectedValues = newValue.map((item) => item.value);
    setFilters((prev) => ({
      ...prev,
      designations: selectedValues,
      users: []
    }));
  }}
  renderInput={(params) => <TextField {...params} label="Designation" fullWidth />}
  sx={{ width: "100%" }}
/>

            {/* Users */}

            <Autocomplete
  multiple
  disableCloseOnSelect
  options={userOptions}
  getOptionLabel={(option) => `${option.name} (${option.id}::${option.designation})`}
  value={filters.users}
  isOptionEqualToValue={(option, value) => option.id === value.id}
  onChange={(_, newValue) => {
    setFilters((prev) => ({
      ...prev,
      users: newValue
    }));
  }}
  renderInput={(params) => <TextField {...params} label="User" fullWidth />}
  sx={{ width: "100%" }}
  disabled={userOptions.length === 0}
  ListboxProps={{
    onScroll: (event: React.UIEvent<HTMLUListElement>) => {
      const listboxNode = event.currentTarget;
      const scrollBottom = listboxNode.scrollHeight - listboxNode.scrollTop - listboxNode.clientHeight;
      if (scrollBottom < 50 && hasMoreUsers && !isLoadingUsers) {
        loadUsersPaginated(); // Load more users when nearing the bottom
      }
    }
  }}
/>


           {/* Date Fields Side by Side */}
           <Box display="flex" gap={2}>
  <DatePicker
    label="From Date"
    value={filters.startDate}
    onChange={handleStartDateChange}
    disablePast
    inputFormat="YYYY-MM-DD"
    renderInput={(params) => <TextField {...params} fullWidth />}
   
  />

  <DatePicker
    label="To Date"
    value={filters.endDate ? dayjs(filters.endDate) : null}
    onChange={handleEndDateChange}
    disablePast
    minDate={filters.startDate}
    inputFormat="YYYY-MM-DD"
    renderInput={(params) => <TextField {...params} fullWidth />}
  />
</Box>

<ConfirmationPopUp
  openConfirmModal={confirmationPopUp}
  message={popUpMessage}
  setOpenConfirmModal={() => {
    setConfirmationPopUp(false);
  }}
  successMethod={popUpSuccessMethod.current}
/>



            {/* Apply Button */}
            <Box display="flex" justifyContent="center" gap={2}>
  <Button variant="outlined" color="secondary" onClick={handleCancel}>
    Cancel
  </Button>
  <Button variant="contained" color="primary" onClick={handleApply}>
    Delete
  </Button>
</Box>


          </Box>
        </Paper>
      </LocalizationProvider>
    </div>
  );
};

export default DeleteUserPJP;
